import { OrderType } from './../../enums/order-type.enum';
import { DictionaryValue } from './../dictionary/dictionaryValue';
import { BaseClass } from '../base-class';
import { Client } from '../client';
import { User } from '../user/user';
import { OrderStatus } from '@enums/order-status.enum';
import { Site } from '@classes/site';
import { RecurringOrderStep } from './recurringOrderStep';

export class RecurringOrder extends BaseClass {
  identifier: string;
  site: Site;
  urgency: DictionaryValue;
  lot?: DictionaryValue;
  dispatcherComment: string;
  sender: RecurringOrderStep;
  receivers: RecurringOrderStep[];
  ordererComment?: string;
  ordererPhone?: string;
  ordererName: string;
  status: OrderStatus;
  type: OrderType;
  cronExpression: string;
  cronDescription: string;
  minutesToAdd: number;

  isDeleted?: boolean;
  transportVoucher?: string;
  startTime?: string;

  transportTypes: DictionaryValue[];

  client?: Client;

  modifiedFields?: string[];

  tagScanned: string;
  arrivedOn?: Date;
  completedOn?: Date;
  scansPickedGroupedByContainer?: any = {};
  scansDeliveredGroupedByContainer?: any = {};

  isVerySoon?: boolean;

  startDate?: Date;
  creationDate?: Date;
  intervalDays?: number;

  constructor();
  constructor(
    site: Site,
    urgency: DictionaryValue,
    ordererPhone: string,
    ordererName: string,
    sender: RecurringOrderStep,
    receivers: RecurringOrderStep[],
    transportTypes: DictionaryValue[],
    cronExpression: string,
    minutesToAdd: number,
    ordererComment?: string,
    lot?: DictionaryValue,
  );
  constructor(
    site?: Site,
    urgency?: DictionaryValue,
    ordererPhone?: string,
    ordererName?: string,
    sender?: RecurringOrderStep,
    receivers?: RecurringOrderStep[],
    transportTypes?: DictionaryValue[],
    cronExpression?: string,
    minutesToAdd?: number,
    ordererComment?: string,
    lot?: DictionaryValue,
  ) {
    super();

    this.site = site;
    this.urgency = urgency;
    this.ordererPhone = this.trim(ordererPhone);
    this.ordererName = this.trim(ordererName);
    this.sender = sender;
    this.receivers = receivers;
    this.ordererComment = this.trim(ordererComment);
    this.transportTypes = transportTypes;
    this.cronExpression = cronExpression;
    this.minutesToAdd = minutesToAdd;
    this.lot = lot;
  }

  static fromObject(object: RecurringOrder): RecurringOrder {
    return Object.assign(new RecurringOrder(), {
      ...object,
      site: object.site ? Site.fromObject(object.site) : null,
      urgency: object.urgency
        ? DictionaryValue.fromObject(object.urgency)
        : null,
      lot: object.lot ? DictionaryValue.fromObject(object.lot) : null,
      // sender: object.sender ? Address.fromObject(object.sender) : null
    });
  }

  get display(): string {
    return this.identifier;
  }
}
